import { TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/system";

export const CsTextField = styled(TextField)({
  "& .MuiFormControl-root, .MuiTextField-root": {
    width: "100% !important",
  },
  ".css-1kwu5i4-MuiFormControl-root-MuiTextField-root": {
    minWidth: "auto !important",
    width: "100% !important",
  },
  "& .css-cio0x1-MuiInputBase-root-MuiFilledInput-root": {
    backgroundColor: "rgba(255, 255, 255,)",
  },
  "& .css-cio0x1-MuiInputBase-root-MuiFilledInput-root::before": {
    borderBottomColor: "green",
  },
  "& label.Mui-focused": {
    color:  grey[800],
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: grey[300],
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
        borderColor: "rgba(60, 60, 67, 0.18)",
    },
    "&:hover fieldset": {
        borderColor: "rgba(60, 60, 67, 0.18)",
    },
    "& .MuiInputBase-root , MuiFilledInput-root": {
      backgroundColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(60, 60, 67, 0.18)",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
});
